import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import {
  CALLABLES,
  type SubmitFeedbackInput,
  type SubmitFeedbackResponse,
  type FeedbackDecideInput,
  type FeedbackActionResponse,
  type FeedbackScreenshotUrlResponse,
  type FeedbackGenerateSummaryResponse,
} from '@daaily/shared';

export const callSubmitFeedback = httpsCallable<SubmitFeedbackInput, SubmitFeedbackResponse>(
  functions,
  CALLABLES.SUBMIT_FEEDBACK,
);

export const callFeedbackDecide = httpsCallable<FeedbackDecideInput, FeedbackActionResponse>(
  functions,
  CALLABLES.FEEDBACK_DECIDE,
);

export const callFeedbackAcknowledgeAll = httpsCallable<
  Record<string, never>,
  FeedbackActionResponse
>(functions, CALLABLES.FEEDBACK_ACKNOWLEDGE_ALL);

export const callFeedbackScreenshotUrl = httpsCallable<
  { id: string },
  FeedbackScreenshotUrlResponse
>(functions, CALLABLES.FEEDBACK_SCREENSHOT_URL);

export const callFeedbackGenerateSummary = httpsCallable<
  Record<string, never>,
  FeedbackGenerateSummaryResponse
>(functions, CALLABLES.FEEDBACK_GENERATE_SUMMARY);
